import useOnFreeTextEdit from './useOnFreeTextEdit';

export default useOnFreeTextEdit;